module.exports = __webpack_public_path__ + "img/American_Credit_Team.5f87701.png";